import "./analytics/initClientAnalytics";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Dev helper: enable desktop tab UI in the browser without Electron
if (
  process.env.REACT_APP_ELECTRON === "true" &&
  typeof window !== "undefined" &&
  !window.electronAPI
) {
  window.electronAPI = { platform: "web", isDesktopApp: true };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
